import { Component, Input } from '@angular/core';
import { GridEditService } from '@common/services/grid-edit.service';

@Component({
    selector: 'app-vessel-notification-waste-grid',
    templateUrl: './vessel-notification-waste-grid.component.html',
})
export class VesselNotificationWasteGridComponent {
    @Input() model: any;
    @Input() canAddNew: boolean = true;
    @Input() canEdit: boolean;
    @Input() editMode: any;

    constructor(public gridEdit: GridEditService) {}

    defaultDisplayValue(property: any, type: string | number): string {
        return this.gridEdit.defaultDisplayValue(property, type, this.model.wasteDeliveryId);
    }
}
